import { render } from "./NotificationsBell.vue?vue&type=template&id=208fb384"
import script from "./NotificationsBell.vue?vue&type=script&lang=js"
export * from "./NotificationsBell.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dawndo/bestphone/main_apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__